import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import { Item as MenuItem } from 'rc-menu';
import styled from 'styled-components';
import { resolveColor } from '../../ThemeOptions';
var StyledMenuItem = styled(MenuItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n    cursor: pointer !important;\n    &.rc-menu-item:hover{\n        cursor: pointer !important;\n    }\n    &.rc-menu-item-active, &.rc-menu-submenu-active > .rc-menu-submenu-title {\n        cursor: pointer !important;\n        background: ", ";\n        color: ", ";\n    }\n    \n    &.rc-menu-item-selected {\n        cursor: pointer !important;\n        background: ", ";\n        color: ", ";\n    }\n"], ["\n    background: ",
    ";\n    color: ", ";\n    cursor: pointer !important;\n    &.rc-menu-item:hover{\n        cursor: pointer !important;\n    }\n    &.rc-menu-item-active, &.rc-menu-submenu-active > .rc-menu-submenu-title {\n        cursor: pointer !important;\n        background: ",
    ";\n        color: ",
    ";\n    }\n    \n    &.rc-menu-item-selected {\n        cursor: pointer !important;\n        background: ",
    ";\n        color: ",
    ";\n    }\n"])), function (p) {
    return resolveColor(p.ioTheme, p.ioMode, p.styleName, 'menubackground');
}, function (p) { return resolveColor(p.ioTheme, p.ioMode, p.styleName, 'menucolor'); }, function (p) {
    return resolveColor(p.ioTheme, p.ioMode, p.styleName, 'menuitemselectedbgcolor');
}, function (p) {
    return resolveColor(p.ioTheme, p.ioMode, p.styleName, 'menuhovercolor');
}, function (p) {
    return resolveColor(p.ioTheme, p.ioMode, p.styleName, 'menuitemselectedbgcolor');
}, function (p) {
    return resolveColor(p.ioTheme, p.ioMode, p.styleName, 'menuitemselectedcolor');
});
var BTMenuItem = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledMenuItem, __assign({}, props, { key: props.key, style: { fontWeight: '700' } }), props.name)));
};
export default React.memo(BTMenuItem);
var templateObject_1;
//# sourceMappingURL=BTMenuItem.js.map